import { Component, inject, effect, ChangeDetectionStrategy } from '@angular/core';
import { ErrorMessageContentComponent } from './error-message-content/error-message-content.component';
import { MatDialog } from '@angular/material/dialog';
import { ErrorService } from '../services/error.service';

@Component({
  selector: 'app-mareon-error-handler',
  changeDetection: ChangeDetectionStrategy.Eager,
  template: '',
})
export class ErrorHandlerComponent {
  private readonly errorService = inject(ErrorService);
  private readonly matDialog = inject(MatDialog);

  constructor() {
    effect(() => {
      const error = this.errorService.onError();
      if (error) {
        this.matDialog.open(ErrorMessageContentComponent, { data: error, width: '50%', height: 'auto' });
      }
    });
  }
}
